import { Routes } from '@angular/router'
import { AuthLogin } from './components/portal/auth/login/login.component'
import { AuthEntry } from './components/portal/auth/entry/entry.component'
import { SchedulePortal } from './components/portal/schedule/schedule.component'
import { Availability } from './components/portal/availability/availability.component'
import { LeaveRequestComp } from './components/portal/leave/leave-request.component'
import { AccountSetting } from './components/portal/account-setting/account-setting.component'
import { PersonalInfo } from './components/portal/personal-info/personal-info.component'
import { authGuard } from './guards/auth.guard'
import { AuthRegister } from './components/portal/auth/register/register.component'
import { ForgotPassword } from './components/portal/auth/forgot-password/forgot-password.component'

export const routes: Routes = [
  {
    path: 'schedule',
    title: 'schedule',
    component: SchedulePortal,
    canActivate: [authGuard]
  },
  {
    path: 'availability',
    title: 'availability',
    component: Availability,
    canActivate: [authGuard]
  },
  {
    path: 'leave-request',
    title: 'leaveRequest',
    component: LeaveRequestComp,
    canActivate: [authGuard]
  },

  {
    path: 'account-setting',
    title: 'accountSetting',
    component: AccountSetting,
    canActivate: [authGuard]
  },
  {
    path: 'personal-info',
    title: 'personalInfo',
    component: PersonalInfo,
    canActivate: [authGuard]
  },
  {
    path: 'auth',
    component: AuthEntry,
    children: [
      { path: 'login', component: AuthLogin },
      { path: 'register', component: AuthRegister },
      { path: 'forgot-password', component: ForgotPassword }
    ]
  },
  { path: '', redirectTo: 'schedule', pathMatch: 'full' },
  { path: '**', redirectTo: 'schedule' }
]
